const quickTags = ['顶流瓜', '综艺名场面', '压哨转会', '红毯生图', '老剧重启', '带货翻车'];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Neon%20city%20skyline%20at%20dusk%20with%20crowds%20gathered%20watching%20bright%20digital%20screens%2C%20energetic%20editorial%20atmosphere%2C%20warm%20orange%20and%20crimson%20tones%2C%20wide%20cinematic%20composition&width=1600&height=900&seq=chigua-hero-bg&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-background-50"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-16 pt-24 text-center md:px-6 md:pb-20 md:pt-28">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium tracking-wide text-background-50 backdrop-blur">
          <i className="ri-fire-line"></i>
          全民围观，节奏同频
        </span>
        <h1 className="max-w-4xl text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          朝阳吃瓜热门话题，
          <span className="block">从朝阳吃瓜榜到头条热议一网打尽</span>
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-50/90 md:text-base">
          聚合散落各平台的朝阳吃瓜热议焦点，实时刷新朝阳吃瓜头条。不必逐条翻全网，
          直接看当下最受关注的“瓜”是哪几个，跟上围观节奏，加入讨论。
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#bang"
            className="w-full whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:w-auto"
          >
            查看今日吃瓜榜
          </a>
          <a
            href="#tougao"
            className="w-full whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition hover:bg-background-50/20 sm:w-auto"
          >
            我要投稿
          </a>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {quickTags.map((t) => (
            <a
              key={t}
              href="#rehua"
              className="rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-xs text-background-50/90 backdrop-blur transition hover:bg-background-50/20"
            >
              # {t}
            </a>
          ))}
        </div>

        <dl className="mt-12 grid w-full grid-cols-3 gap-3 rounded-2xl border border-background-50/15 bg-background-50/10 p-4 backdrop-blur md:max-w-3xl md:gap-6 md:p-6">
          {[
            ['12.6万', '今日新增热议'],
            ['4.8亿', '累计围观热度'],
            ['38', '在线瓜友频道'],
          ].map(([num, label]) => (
            <div key={label} className="text-center">
              <dt className="sr-only">{label}</dt>
              <dd className="font-heading text-xl font-bold text-background-50 md:text-3xl">{num}</dd>
              <dd className="mt-1 text-xs text-background-50/75 md:text-sm">{label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}